import React, { Suspense, lazy } from 'react';
import LoadingScreen from './components/LoadingScreen';
import ErrorBoundary from './components/ErrorBoundary';

// Lazy load components for better performance
const Hero = lazy(() => import('./components/Hero'));
const Navigation = lazy(() => import('./components/Navigation'));
const Destinations = lazy(() => import('./components/Destinations'));
const Culture = lazy(() => import('./components/Culture'));
const Tips = lazy(() => import('./components/Tips'));
const TravelPlanner = lazy(() => import('./components/TravelPlanner'));
const Footer = lazy(() => import('./components/Footer'));

function App() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<LoadingScreen />}>
        <div className="min-h-screen bg-cream">
          <Hero />
          <Navigation />
          <Destinations />
          <Culture />
          <Tips />
          <TravelPlanner />
          <Footer />
        </div>
      </Suspense>
    </ErrorBoundary>
  );
}

export default App;